import { useMemo } from "react";

interface BusinessProfile {
  name: string;
  // Extendable later: logo, address, email, phone, taxId, currency, timezone
}

interface HookResult {
  data: BusinessProfile | null;
  loading: boolean;
  error: string | null;
}

// Reads the current business profile. Backend wires to the signed-in user's
// business record later. For now returns a local profile.
const CURRENT_PROFILE: BusinessProfile = {
  name: "BrightCare Home Healthcare Services Inc.",
};

export function useBusinessProfile(): HookResult {
  const data = useMemo(() => CURRENT_PROFILE, []);
  return { data, loading: false, error: null };
}